import type { SxProps, Theme } from '@mui/material';

export const articleContentSx: SxProps<Theme> = (theme) => ({
  fontSize: 14,
  lineHeight: 1.8,
  color: theme.palette.text.primary,
  mx: 'auto',
  h1: {
    fontSize: '1.5rem',
    lineHeight: '2rem',
    '@media (max-width:899.95px)': {
      fontSize: '1.25rem',
      lineHeight: '1.75rem'
    }
  },
  h2: {
    fontSize: '1.25rem',
    lineHeight: '1.75rem',
    '@media (max-width:899.95px)': {
      fontSize: '1.125rem',
      lineHeight: '1.5rem'
    }
  },
  h3: {
    fontSize: '0.875rem',
    lineHeight: '1.25rem'
  },
  h6: {
    fontSize: '1.25rem',
    lineHeight: '1.75rem',
    '@media (max-width:899.95px)': {
      fontSize: '1.125rem',
      lineHeight: '1.5rem'
    }
  },
  '& p': {
    margin: `${theme.spacing(1.5)} 0`,
    color: theme.palette.secondary.main
  },
  'p:has(+ ul)': {
    color: theme.palette.common.black
  },
  '& strong': {
    color: theme.palette.common.black
  },
  '& ul, & ol': {
    paddingLeft: theme.spacing(3.5),
    margin: `${theme.spacing(2.5)} 0`
  },
  '& li': {
    margin: `${theme.spacing(1.25)} 0`,
    '& p': {
      color: theme.palette.common.black
    }
  },
  '& a': {
    color: `${theme.palette.primary.main} !important`,
    textDecoration: 'underline',
    '& strong': {
      color: theme.palette.primary.main
    }
  },
  '& code': {
    backgroundColor: theme.palette.grey[100],
    padding: '2px 6px',
    borderRadius: theme.spacing(0.5),
    fontFamily: 'monospace',
    fontSize: '0.9em'
  },
  '& blockquote': {
    borderLeft: `4px solid ${theme.palette.primary.main}`,
    paddingLeft: theme.spacing(2.25),
    color: theme.palette.text.secondary,
    margin: `${theme.spacing(2.5)} 0`
  },
  '& hr': {
    border: 'none',
    borderTop: `1px solid ${theme.palette.divider}`,
    margin: `${theme.spacing(4)} 0`
  }
});
